import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import ProtocolSection from '../components/ProtocolSection';
import ProductGrid from '../components/ProductGrid';
import WhyIntegratedWellness from '../components/WhyIntegratedWellness';
import FAQ from '../components/FAQ';
import CTA from '../components/CTA';
import Footer from '../components/Footer';
import ChatBot from '../components/ChatBot';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main id="main-content" className="hbk-public-copy" tabIndex={-1} data-testid="home-main-content">
        <Hero />
        <HowItWorks />
        <ProtocolSection />
        <ProductGrid />
        <WhyIntegratedWellness />
        <CTA />
        <FAQ />
      </main>
      <ChatBot />
      <Footer />
    </div>
  );
}